/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Custom_Property_Link_Rule_Type_AutoopenintabInputs */

const en_enum_custom_property_link_rule_type_autoopenintab = /** @type {(inputs: Enum_Custom_Property_Link_Rule_Type_AutoopenintabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Property Link Rule Type Autoopenintab`)
};

const de_enum_custom_property_link_rule_type_autoopenintab = /** @type {(inputs: Enum_Custom_Property_Link_Rule_Type_AutoopenintabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link automatisch in neuem Tab öffnen`)
};

/**
* | output |
* | --- |
* | "Property Link Rule Type Autoopenintab" |
*
* @param {Enum_Custom_Property_Link_Rule_Type_AutoopenintabInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const enum_custom_property_link_rule_type_autoopenintab = /** @type {((inputs?: Enum_Custom_Property_Link_Rule_Type_AutoopenintabInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Custom_Property_Link_Rule_Type_AutoopenintabInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_custom_property_link_rule_type_autoopenintab(inputs)
	return de_enum_custom_property_link_rule_type_autoopenintab(inputs)
});